import React from 'react';
import CarouselPage from '../carousel/carousel';

export default function Home(props){
    return <div>
      
        <CarouselPage/>
    </div>

}